module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.settings) ? _c('div', {
    staticClass: "box"
  }, [_c('b-field', {
    attrs: {
      "label": "Телефон"
    }
  }, [_c('b-input', {
    on: {
      "change": _vm.handleUpdate
    },
    model: {
      value: (_vm.settingsObject.phone),
      callback: function($$v) {
        _vm.$set(_vm.settingsObject, "phone", $$v)
      },
      expression: "settingsObject.phone"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Почта для ЛК"
    }
  }, [_c('b-input', {
    on: {
      "change": _vm.handleUpdate
    },
    model: {
      value: (_vm.settingsObject.siteEmail),
      callback: function($$v) {
        _vm.$set(_vm.settingsObject, "siteEmail", $$v)
      },
      expression: "settingsObject.siteEmail"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Почта для заявок на договор (через запятую)"
    }
  }, [_c('b-input', {
    on: {
      "change": _vm.handleUpdate
    },
    model: {
      value: (_vm.settingsObject.requestsEmail),
      callback: function($$v) {
        _vm.$set(_vm.settingsObject, "requestsEmail", $$v)
      },
      expression: "settingsObject.requestsEmail"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Почта для заявок на вебинар (через запятую)"
    }
  }, [_c('b-input', {
    on: {
      "change": _vm.handleUpdate
    },
    model: {
      value: (_vm.settingsObject.webinarsEmail),
      callback: function($$v) {
        _vm.$set(_vm.settingsObject, "webinarsEmail", $$v)
      },
      expression: "settingsObject.webinarsEmail"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Почта для заявок на мероприятия (через запятую)"
    }
  }, [_c('b-input', {
    on: {
      "change": _vm.handleUpdate
    },
    model: {
      value: (_vm.settingsObject.eventsEmail),
      callback: function($$v) {
        _vm.$set(_vm.settingsObject, "eventsEmail", $$v)
      },
      expression: "settingsObject.eventsEmail"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Адрес (в подвал)"
    }
  }, [_c('b-input', {
    attrs: {
      "type": "textarea"
    },
    on: {
      "change": _vm.handleUpdate
    },
    model: {
      value: (_vm.settingsObject.address),
      callback: function($$v) {
        _vm.$set(_vm.settingsObject, "address", $$v)
      },
      expression: "settingsObject.address"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Копирайты, лицензии"
    }
  }, [_c('Editor', {
    attrs: {
      "editorToolbar": _vm.customToolbar
    },
    model: {
      value: (_vm.text),
      callback: function($$v) {
        _vm.text = $$v
      },
      expression: "text"
    }
  })], 1), _vm._v(" "), _c('h3', [_vm._v("Социальные сети")]), _vm._v(" "), _c('div', {
    staticClass: "social"
  }, [_c('p', [_c('img', {
    attrs: {
      "src": "/static/img/icons/social/vk.svg"
    }
  }), _vm._v(" "), _c('b-input', {
    on: {
      "change": _vm.handleUpdate
    },
    model: {
      value: (_vm.settingsObject.social.vk),
      callback: function($$v) {
        _vm.$set(_vm.settingsObject.social, "vk", $$v)
      },
      expression: "settingsObject.social.vk"
    }
  })], 1), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": "/static/img/icons/social/youtube.svg"
    }
  }), _vm._v(" "), _c('b-input', {
    on: {
      "change": _vm.handleUpdate
    },
    model: {
      value: (_vm.settingsObject.social.youtube),
      callback: function($$v) {
        _vm.$set(_vm.settingsObject.social, "youtube", $$v)
      },
      expression: "settingsObject.social.youtube"
    }
  })], 1), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": "/static/img/icons/social/ok.svg"
    }
  }), _vm._v(" "), _c('b-input', {
    on: {
      "change": _vm.handleUpdate
    },
    model: {
      value: (_vm.settingsObject.social.ok),
      callback: function($$v) {
        _vm.$set(_vm.settingsObject.social, "ok", $$v)
      },
      expression: "settingsObject.social.ok"
    }
  })], 1), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": "/static/img/icons/social/rutube.svg"
    }
  }), _vm._v(" "), _c('b-input', {
    on: {
      "change": _vm.handleUpdate
    },
    model: {
      value: (_vm.settingsObject.social.rutube),
      callback: function($$v) {
        _vm.$set(_vm.settingsObject.social, "rutube", $$v)
      },
      expression: "settingsObject.social.rutube"
    }
  })], 1), _vm._v(" "), _c('p', [_c('img', {
    attrs: {
      "src": "/static/img/icons/social/telegram.svg"
    }
  }), _vm._v(" "), _c('b-input', {
    on: {
      "change": _vm.handleUpdate
    },
    model: {
      value: (_vm.settingsObject.social.telegram),
      callback: function($$v) {
        _vm.$set(_vm.settingsObject.social, "telegram", $$v)
      },
      expression: "settingsObject.social.telegram"
    }
  })], 1)]), _vm._v(" "), _c('h3', [_vm._v("Документы")]), _vm._v(" "), _c('div', {
    staticClass: "settings-files"
  }, [_c('p', [_c('strong', [_vm._v("Политика защиты:")]), _vm._v(" "), (!_vm.settings.securityPolicyFile) ? _c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        return _vm.$refs.loadPolicyButton.click()
      }
    }
  }, [_vm._v("Загрузить")]) : _c('span', [_c('a', {
    attrs: {
      "href": _vm.settings.securityPolicyFile,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm._f("formatFileName")(_vm.settings.securityPolicyFile)))]), _vm._v(" "), _c('span', {
    staticClass: "delete-document",
    on: {
      "click": function($event) {
        return _vm.deletePolicyFile()
      }
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('input', {
    ref: "loadPolicyButton",
    attrs: {
      "type": "file",
      "hidden": ""
    },
    on: {
      "change": _vm.handleLoadPolicyFile
    }
  })]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Согласие на обработку данных:")]), _vm._v(" "), (!_vm.settings.agreementFile) ? _c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        return _vm.$refs.loadAgreementButton.click()
      }
    }
  }, [_vm._v("Загрузить")]) : _c('span', [_c('a', {
    attrs: {
      "href": _vm.settings.agreementFile,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm._f("formatFileName")(_vm.settings.agreementFile)))]), _vm._v(" "), _c('span', {
    staticClass: "delete-document",
    on: {
      "click": function($event) {
        return _vm.deleteAgreementFile()
      }
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('input', {
    ref: "loadAgreementButton",
    attrs: {
      "type": "file",
      "hidden": ""
    },
    on: {
      "change": _vm.handleLoadAgreementFile
    }
  })]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("СОГЛАСИЕ на получение информации и рассылок:")]), _vm._v(" "), (!_vm.settings.infoMailingFile) ? _c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        return _vm.$refs.loadInfoMailingButton.click()
      }
    }
  }, [_vm._v("Загрузить")]) : _c('span', [_c('a', {
    attrs: {
      "href": _vm.settings.infoMailingFile,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm._f("formatFileName")(_vm.settings.infoMailingFile)))]), _vm._v(" "), _c('span', {
    staticClass: "delete-document",
    on: {
      "click": function($event) {
        return _vm.deleteInfoMailingFile()
      }
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('input', {
    ref: "loadInfoMailingButton",
    attrs: {
      "type": "file",
      "hidden": ""
    },
    on: {
      "change": _vm.handleLoadInfoMailingFile
    }
  })]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Согласие на обработку персональных данных при проведении депозитарием:")]), _vm._v(" "), (!_vm.settings.depositoryConsentFile) ? _c('span', {
    staticClass: "link",
    on: {
      "click": function($event) {
        return _vm.$refs.loadDepositoryConsentButton.click()
      }
    }
  }, [_vm._v("Загрузить")]) : _c('span', [_c('a', {
    attrs: {
      "href": _vm.settings.depositoryConsentFile,
      "target": "_blank",
      "rel": "noopener noreferrer"
    }
  }, [_vm._v(_vm._s(_vm._f("formatFileName")(_vm.settings.depositoryConsentFile)))]), _vm._v(" "), _c('span', {
    staticClass: "delete-document",
    on: {
      "click": function($event) {
        return _vm.deleteDepositoryConsentFile()
      }
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('input', {
    ref: "loadDepositoryConsentButton",
    attrs: {
      "type": "file",
      "hidden": ""
    },
    on: {
      "change": _vm.handleLoadDepositoryConsentFile
    }
  })])]), _vm._v(" "), _c('h3', [_vm._v("Меню в подвале")]), _vm._v(" "), _c('div', {
    staticClass: "is-flex footer-menu-generator"
  }, [_c('div', [_c('strong', [_vm._v("Левый столбец")]), _vm._v(" "), _c('draggable', {
    model: {
      value: (_vm.leftFooterItems),
      callback: function($$v) {
        _vm.leftFooterItems = $$v
      },
      expression: "leftFooterItems"
    }
  }, _vm._l((_vm.leftFooterItems), function(item) {
    return _c('FooterItem', {
      key: item.id,
      attrs: {
        "item": item
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "centered"
  }, [_c('span', {
    staticClass: "button-wrapper",
    on: {
      "click": _vm.addToLeftColumn
    }
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v("Добавить элемент\n        ")])])], 1), _vm._v(" "), _c('div', [_c('strong', [_vm._v("Правый столбец")]), _vm._v(" "), _c('draggable', {
    model: {
      value: (_vm.rightFooterItems),
      callback: function($$v) {
        _vm.rightFooterItems = $$v
      },
      expression: "rightFooterItems"
    }
  }, _vm._l((_vm.rightFooterItems), function(item) {
    return _c('FooterItem', {
      key: item.id,
      attrs: {
        "item": item
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "centered"
  }, [_c('span', {
    staticClass: "button-wrapper",
    on: {
      "click": _vm.addToRightColumn
    }
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v("Добавить элемент\n        ")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "save-content-button centered"
  }, [_c('button', {
    staticClass: "button save-content",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": function($event) {
        return _vm.handleSaveSetting()
      }
    }
  }, [_vm._v(_vm._s(_vm.disabled ? 'Идет сохранение...' : 'СОХРАНИТЬ'))])])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-faaf64f0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Settings/Index.vue
// module id = 1010
// module chunks = 0